import LegalPage from "./LegalPage";
import { termsOfUsePage } from "./legalContent";

function TermsOfUse() {
  return <LegalPage page={termsOfUsePage} />;
}

export default TermsOfUse;
